import {
  Body,
  Box,
  Heading,
  VStack,
  useBreakpointValue,
} from '@hover/blueprint';
import React from 'react';

import type { TranslationNamespaceType } from 'src/i18n/types';
import { Button } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import type { ButtonPressed } from 'src/shared/telemetry';

const HeroSection = ({
  onTryClick,
  translationName,
  ctaTrackingData,
}: {
  onTryClick: () => void;
  translationName: TranslationNamespaceType;
  ctaTrackingData?: Partial<ButtonPressed>;
}) => {
  const t = useTranslate(translationName);
  const heading = t('heroHeader');
  const description = useBreakpointValue({
    base: t('subHeader.mobile'),
    tablet: t('subHeader.tablet'),
  });

  const { job_id: _, ...relevantTrackingData } = ctaTrackingData || {};

  return (
    <VStack
      alignItems={{ base: 'flex-start', width250: 'center' }}
      pb={{ base: 500, tablet: 900 }}
      pt={{ base: 800, tablet: 900 }}
      px={{ base: 500, tablet: undefined }}
    >
      <Box maxWidth={{ tablet: 800, desktop: 900 }}>
        <Heading
          margin="0px !important"
          size={{ base: 700, desktop: 900 }}
          textAlign={{ base: 'left', width250: 'center' }}
        >
          {heading}
        </Heading>
      </Box>
      <Box maxWidth={{ base: '100%', tablet: 800 }}>
        <Body
          as="span"
          marginBottom={{ base: 500, tablet: 600 }}
          marginTop={200}
          size={{ base: 300, desktop: 400 }}
          textAlign={{ base: 'left', width250: 'center' }}
          textColor="neutral.550"
        >
          {description}
        </Body>
      </Box>
      <Button
        marginTop="0px !important"
        onClick={onTryClick}
        optionalTrackingProperties={relevantTrackingData}
        size="large"
        width={{ base: '100%', width250: 'auto' }}
      >
        {t('tryItWithYourPlace')}
      </Button>
    </VStack>
  );
};

export { HeroSection };
